import DetailDialog from '@/components/provincial_level/detail_dialog/detail_dialog';
import QrcodeDialog from '@/components/provincial_level/qrcode_dialog/qrcode_dialog';
import InsuranceDialog from '@/components/insurance_dialog/insurance_dialog';
import cardSvg from '@/assets/images/provincial/card.svg';
import WDCS from '@/assets/images/wdcs.svg';
import transportSvg from '@/assets/images/provincial/transport.svg';
import nameSvg from '@/assets/images/provincial/name.svg';
import piyaoSvg from '@/assets/images/mini/piyao.svg';
import edu2Svg from '@/assets/images/my_cs/edu.svg';
import moneySvg from '@/assets/images/my_cs/money.svg';
import redCrossSvg from '@/assets/images/red_cross.svg'
import qrcdoeSvg from '@/assets/images/qrcode.svg'
import redCsSvg from '@/assets/images/red_cs.jpg'

export default{
    name : 'edu_service',
    data () {
        return {
            // 是否显示弹出层
            isShowDialog: false,
            // 弹出层标题
            dialogTitle: '',
            // 五险一金
            isShowInsurance: false,
            // 弹出层数组
            dialogList: [],
            lock: false,
            list: [/*{
                menuName: '在线咨询',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=8;1;1',
                icon: '#icon-zaixianzixun'
            },{
                menuName: '驾培服务',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;21;1',
                icon: '#icon-jiapeijiakao'
            },{
                menuName: '户籍证件',
                menuType: 1,
                img: cardSvg,
                subMenu: [
                    {menuName: '港澳台居民居住证',desc: '港澳台居民居住证办理点查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;46;1'},
                    {menuName: '居住登记状态',desc: '居住登记状态查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;47;1'},
                ]
            },{
                menuName: '同名查询',
                menuType: 2,
                img: nameSvg,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=9;20;1',
            },{
                menuName: '开锁换锁',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;23;1',
                icon: '#icon-kaisuohuansuo'
            },{
                menuName: '便民挪车',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;26;1',
                icon: '#icon-nuoche1'
            },{
                menuName: '交通出行',
                menuType: 1,
                img: transportSvg,
                subMenu: [
                    {menuName: '交通运输企业',desc: '交通运输企业查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;15;1'},
                    {menuName: '交通运输班线',desc: '交通运输班线查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;16;1'},
                    {menuName: '驾驶证记分',desc: '驾驶证记分查询',url: 'https://user.cs96111.com/ad/record/url/auth?data=9;17;1'},

                ]
            },*/{
                menuName: '便民码',
                menuType: 1,
                img: qrcdoeSvg,
                subMenu: [
                    {menuName: '挪车二维码',desc: '挪车二维码',url: 'https://user.cs96111.com/ad/record/url/auth?data=10;26;1',self: true}
                ]
            }, {
                menuName: '便民公益',
                menuType: 1,
                img: redCrossSvg,
                subMenu: [
                    {img: redCsSvg,menuName: '长沙红十字志愿服务队',desc: '长沙红十字志愿服务队志愿者招募',url: 'https://user.cs96111.com/ad/record/url/auth?data=31;2;1',self: true}
                ],
            },{
                menuName: '开锁换锁',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;23;1',
                icon: '#icon-kaisuohuansuo'
            }, {
                menuName: '我的长沙',
                menuType: 3,
                img: WDCS,
                url: '',
                miniId: 'gh_7f57f7d2417e',
                data: '19;71;1'
            }, {
                menuName: '辟谣中心',
                menuType: 3,
                img: piyaoSvg,
                url: '',
                miniId: 'gh_073520b838a0',
                data: '20;84;1'
            },{
                menuName: '学区查询',
                menuType: 3,
                img: edu2Svg,
                url: 'sub-other/pages/school-district-query/index.html?type=sz&title=学区查询',
                miniId: 'gh_7f57f7d2417e',
                data: '19;72;1'
            }, {
                menuName: '生活缴费',
                menuType: 1,
                img: moneySvg,
                subMenu: [
                    {menuName: '电费',desc: '电费缴费',url: 'packquery/pages/form-agency/form-agency?navigateId=272851312207163', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                    {menuName: '水费',desc: '水费缴费',url: 'packquery/pages/form-agency/form-agency?navigateId=272851332073693', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                    {menuName: '燃气费',desc: '燃气费缴费',url: 'packquery/pages/query-guide/query-guide?navigateId=272851328327997', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                    {menuName: '固话费',desc: '固话费缴费',url: 'packquery/pages/query-guide/query-guide?navigateId=272851352281232', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                    {menuName: '宽带费',desc: '宽带费缴费',url: 'packquery/pages/form-agency/form-agency?navigateId=272851341821850', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                    {menuName: '有线电视',desc: '有线电视缴费',url: 'packquery/pages/form-agency/form-agency?navigateId=272851354698235', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                    {menuName: '油卡充值',desc: '油卡充值',url: 'packquery/pages/form-agency/form-agency?navigateId=272851365565027', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                    {menuName: '缴费记录',desc: '缴费记录',url: 'packother/pages/transactions/transactions?navigateId=272851376288437', miniId: 'gh_aceb9bd462ab',data: '20;85;1'},
                ]
            },{
                menuName: '便民U车盟',
                menuType: 2,
                url: 'https://user.cs96111.com/ad/record/url/auth?data=10;25;1',
                icon: '#icon-chefuwu'
            }]
        }
    },
    methods: {
        closeDialog() {
		    this.isShowDialog = false;
        },
        closeInsurance() {
            this.isShowInsurance = false;
        },
		menuClick(item, index) {
            if(item.menuType == 1) {
                this.isShowDialog = true;
                this.dialogTitle = item.menuName
                this.dialogList = item.subMenu
                return;
            } else if(item.menuType == 2) {
                if(item.url == undefined) {
                    this[item.dialog] = true;
                } else {
                    if(item.url.indexOf('auth') != -1 && window.localStorage.getItem("token") != undefined) {
                        window.location.href = (item.url+ '&token=' + window.localStorage.getItem("token"));
                        return;
                    }
                    window.location.href = item.url
                }
            }
        }
    },
    mounted() {
      for(let index = 0; index < this.list.length; index++ ){
          let item = this.list[index]
          if(item.menuType != 3) {
              continue;
          }
          let btn = document.getElementById('launch-btn-a-'+ index);
          btn.addEventListener('launch',  (e) => {
              if(this.lock) {
                  return;
              }
              this.lock = true;
              let url = 'https://user.cs96111.com/ad/record/auth?data='+item.data;
              if(window.localStorage.getItem("token") != undefined) {
                  url += ('&token=' + window.localStorage.getItem("token"))
              }
              $.post(url, (result) => {
                  this.lock = false;
              });
          });
      }
    },
	components: {
        'DetailDialog': DetailDialog,
        'QrcodeDialog': QrcodeDialog,
        'InsuranceDialog': InsuranceDialog
	}
}


// WEBPACK FOOTER //
// ./src/components/provincial_level/common_service/js/common_service.js